import { render, staticRenderFns } from "./TiNotasDeVersao.vue?vue&type=template&id=2099a824"
import script from "./TiNotasDeVersao.vue?vue&type=script&lang=js"
export * from "./TiNotasDeVersao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports